import { render, staticRenderFns } from "./PopupFeatureTour.vue?vue&type=template&id=55ab04fc"
import script from "./PopupFeatureTour.vue?vue&type=script&lang=js"
export * from "./PopupFeatureTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports